import axios from 'axios';
import type { UserInformationResponseDTO } from '~/dto/HybrisAuthenticate/getUserInformation';
import apiHybris from '~/services/apiHybris';
import { useUserInfoStore, type UserType } from '~/stores/userInfo';
import {
  GENERIC_ERROR_OK_EMPTY_RESPONSE,
  getFriendlyError,
} from '~/utils/getFriendlyError';

export async function GetUserInformationUseCase(token: string) {
  try {
    const response = await apiHybris.get<UserInformationResponseDTO>(
      'users/current',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const { cpfCnpj, email, id, name, cellPhone } = response.data;
    const userInfo: UserType = {
      document: cpfCnpj,
      email,
      token,
      id,
      name,
      phone: cellPhone,
      contractedServices: [],
    };
    useUserInfoStore.getState().setUserInfo(userInfo);
  } catch (error) {
    useUserInfoStore.getState().deleteUserInfo();
    if (axios.isAxiosError(error)) {
      if (!error.response || !error.response.data) {
        error.message = GENERIC_ERROR_OK_EMPTY_RESPONSE;
      } else {
        const { error: errorType, error_description } = error.response.data;
        error.message = getFriendlyError(errorType, error_description);
      }
    }
    throw error;
  }
}
